<!-- Text Area Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <textarea [id]="name"
      [attr.aria-labelledby]="name + '_label'"
      [rows]="rows"
      [cols]="cols"
      [class]="inputClass + ' min-h-5rem'"
      [autoResize]="autoResize"
      [formControlName]="name"
      [disableControl]="disabled"
      [placeholder]="placeholder | translate"
      [ngClass]="{
        'ng-invalid': control.invalid && control.touched,
        'ng-dirty': control.invalid && control.dirty,
      }"
      (change)="valueChange.emit($event)"
      pInputTextarea>
    </textarea>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}